import { AnimateProvider } from '@features/animations/components/animate-provider';
import { AnimatedFadeComponent } from '@features/animations/components/animated-fade-component';
import { NAVBAR_ANIMATION_DURATION } from '@features/animations/constants/animations';
import { Link } from '@features/shared/components/link';
import { useNavigate } from '@features/shared/hooks/use-navigate';
import ChevronLeftIcon from '@heroicons/react/24/solid/ChevronLeftIcon';
import { useLocation, useSearchParams } from 'react-router-dom';

export function LeftComponent() {
  const location = useLocation();
  const { lastPathname, goBack } = useNavigate();
  const [searchParams] = useSearchParams();

  const shouldUseBackButton = location.pathname !== '/';

  const redirectUri = searchParams.get('redirectUri');

  function handleBackNavigation() {
    if (redirectUri) {
      return;
    }

    if (lastPathname) {
      goBack();
    } else {
      window.location.pathname = '/';
    }
  }

  return (
    <AnimateProvider>
      {shouldUseBackButton && (
        <AnimatedFadeComponent
          key="back-button"
          duration={NAVBAR_ANIMATION_DURATION}
        >
          <Link
            to={redirectUri ?? '#'}
            onClick={handleBackNavigation}
            replace={!!redirectUri}
          >
            <div className="flex items-center min-w-16 min-h-12">
              <ChevronLeftIcon className="size-6 text-l-green-700" />
            </div>
          </Link>
        </AnimatedFadeComponent>
      )}
    </AnimateProvider>
  );
}
